// Sidebar.tsx (Update the path of the Logout button)
import React, { useEffect, useState } from 'react';
import { Avatar, List, useTheme } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SidebarItem from './SidebarItem';
import { useAuth } from '../../contexts/AuthContext';
import { useLoading } from '../../contexts/LoadingContext';
import { useNavigate } from 'react-router-dom';
import { useFetch } from '../../utils/FetchTemplate';
import { useSetting } from '../../contexts/SettingContext';
import { Role } from '../../interfaces/constants';

const Sidebar: React.FC = () => {
  const theme = useTheme();
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [password, setPassword] = useState('');
  const { source, logout } = useAuth();
  const { settings } = useSetting();
  const [imagePath, setImagePath] = useState<string>(() => {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    // settings.profilePicture is the canonical path used elsewhere in the app
    const path = (settings as any)?.profilePicture as string | undefined;
    return path ? base + path : '';
  });
  const navigate = useNavigate();
  const { postData, getData } = useFetch()
  const [subItems, setSubItems] = useState<any[]>([]);

  useEffect(() => {
    const role = settings?.profile?.role;
    if (!role) return;

    if (role === Role.Teacher || role === Role.Student) {
      setSubItems([
        { text: 'Account', icon: <DashboardIcon />, path: '/dashboard/setting/account' },
        { text: 'Profile', icon: <DashboardIcon />, path: '/dashboard/setting/profile' },
        { text: 'Service', icon: <DashboardIcon />, path: '/dashboard/setting/service' },
      ]);
    } else if (role === Role.Admin) {
      setSubItems([
        { text: 'Profile', icon: <DashboardIcon />, path: '/dashboard/setting/profile' },
        { text: 'Account', icon: <DashboardIcon />, path: '/dashboard/setting/account' },
        { text: 'Service', icon: <DashboardIcon />, path: '/dashboard/setting/service' },
        { text: 'Payment History', icon: <DashboardIcon />, path: '/dashboard/setting/payments' },
        // { text: 'File Upload', icon: <DashboardIcon />, path: '/dashboard/setting/file-download' },
        // { text: 'Manage Subscription', icon: <DashboardIcon />, path: '/dashboard/setting/manageSubscription' }
      ]);
      console.log("ADMIN ROLE")
    }

  }, [source, settings]);

  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleLogout = async () => {
    postData('/api/auth/logout', {}).then(() => {
      logout();
      navigate('/signin'); // Replace '/dashboard' with your target route
    }).catch().finally(() => {
    });
  };

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    const path = (settings as any)?.profilePicture as string | undefined;
    setImagePath(path ? base + path : '');
  }, [settings]);

  const displayName = settings.profile.firstName ? (settings.profile.firstName + " " + settings.profile.lastName[0]) : settings.profile.username;
  const role = settings?.profile.role || ''; // 这里直接取 settings.role
  const displayRole = role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();


  console.log('Fetched settings:', settings);
  return (
    <div className="w-64 bg-gray-100 min-h-screen p-4 flex flex-col">
      <div>
        <div className="flex flex-col items-center mb-8">
          <Avatar className="bg-blue-500 mb-2" sx={{ width: 56, height: 56 }} src={imagePath}></Avatar>
          <h2 className="text-xl font-semibold">{displayName}</h2>
          <h2 className="text-xl font-semibold">{displayRole}</h2>
        </div>
        <List>
          {role === Role.Admin && <SidebarItem
            index={0}
            text="Members"
            icon={<PeopleIcon />}
            selectedIndex={selectedIndex}
            handleListItemClick={handleListItemClick}
            path="/dashboard/member"
          />}
          <SidebarItem
            index={1}
            text="Calendar"
            icon={<CalendarTodayIcon />}
            selectedIndex={selectedIndex}
            handleListItemClick={handleListItemClick}
            path="/dashboard"
          />
        </List>
      </div>
      <List>
        <SidebarItem
          index={100} // Ensure these indexes don't clash with sub-items
          text="Settings"
          icon={<SettingsIcon />}
          selectedIndex={selectedIndex}
          handleListItemClick={handleListItemClick}
          path="/dashboard/setting"
          subItems={subItems}
        />
        <SidebarItem
          index={101} // Ensure these indexes don't clash with sub-items
          text="Logout"
          icon={<LogoutIcon />}
          selectedIndex={selectedIndex}
          handleListItemClick={handleLogout}
          path="/signin" // Update to navigate to the sign-in page
        />
      </List>
    </div>
  );
};

export default Sidebar;
